import { useState, useEffect } from "react";
import clsx from "clsx";

export default function ImgWithPlaceholder({
    className = "",
    src = "",
    onError = () => {},
    onload = () => {},
}) {
    const [loadError, setLoadError] = useState(false);

    useEffect(() => {
        setLoadError(false);
    }, [src]);

    const errorEvent = (error) => {
        console.error("Image load error", error);
        onError && onError();
        setLoadError(true);
    };

    const onLoadEvent = () => {
        onload && onload();
    };

    return (
        <img
            className={clsx(className, { "opacity-0": loadError })}
            src={src}
            onLoad={onLoadEvent}
            onError={errorEvent}
        />
    );
}
